import Stack from '@mui/material/Stack/Stack';
import React from 'react';
import { useTranslation } from 'react-i18next';
import manifest from '../../../../package.json';
import Typography from '../../../components/v2/Typography/Typography';
import { formatNumber } from '../../../utils/format-number';
import useSystemStatus from '../../settings/hooks/use-system-status';
import logo from 'assets/images/logo-black.svg';
import { Grid } from '@mui/material';

const SystemSummary = () => {
  const { t } = useTranslation();
  const { data = {} } = useSystemStatus();
  const storageSize = data?.storage?.total?.sizeFormatted;
  const objectsCount = data?.objects;

  return (
    <Typography align="center" variant="caption" component="div">
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <a
            href="https://quodoc.com?utm_source=quodoc_web_app"
            target="_blank"
          >
            <img src={logo} alt="Quodoc" />
          </a>
        </Grid>
        <Grid item xs={8}>
          <Stack
            direction="row"
            justifyContent="flex-end"
            style={{ fontSize: '10px', whiteSpace: 'nowrap' }}
          >
            <span>{manifest.version}</span>
            {storageSize && <span>&nbsp;/&nbsp;{storageSize}</span>}
            {objectsCount > 0 && (
              <span>&nbsp;/&nbsp;{formatNumber(objectsCount)} ID's</span>
            )}
          </Stack>
        </Grid>
      </Grid>
    </Typography>
  );
};

export default SystemSummary;
